import React from "react";
import { VintomError } from "src/api/model/error/VintomError";
import { I18n } from "../../../../i18n/i18n";

import "@styles/c-message.scss";

interface Props {
  i18n: I18n;
  message: string | VintomError;
  onSendError: (error?: VintomError) => void;
}

interface State {
  isAfterErrorSent: boolean;
}

export class MessageComponent extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {
      isAfterErrorSent: false
    };
  }

  render() {
    const { i18n, message } = this.props;

    let messageStr: string;
    let error: VintomError;
    if (this.state.isAfterErrorSent) {
      messageStr = i18n.thankYouForSendingReport;
    } else if (typeof (message) === "string") {
      messageStr = message;
    } else {
      error = message;
    }

    return (
      <div className="c-message">
        <div className="c-message__container">
          <div
            className="c-message__text"
            dangerouslySetInnerHTML={{ __html: messageStr || error && i18n[error.errorCode] }}
          />
          {!this.state.isAfterErrorSent && error &&
            <button
              className="c-message__sendReport"
              onClick={() => this.handleSendError(error)}
            >
              {i18n.sendReport}
            </button>
          }
        </div>
      </div>);
  }

  private handleSendError(error: VintomError) {
    this.props.onSendError(error);
    this.setState({
      isAfterErrorSent: true
    });
  }

}
